import { createFileRoute, notFound } from "@tanstack/react-router";
import servicesStyles from "../styles/services.css?url";
import { TournamentDetail } from "../components/services/tournaments";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { loadTournament } from "../server/services";

/** One selected tournament (/tournaments/:id), with registration on start.gg. */
export const Route = createFileRoute("/tournaments/$id")({
  loader: async ({ params }) => {
    const tournament = await loadTournament({ data: params.id });
    if (!tournament) throw notFound();
    return tournament;
  },
  head: ({ matches, loaderData, match }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    const head = creatorPageHead(shell, {
      pathname: match.pathname,
      title: `${loaderData.source.name || "Tournament"} | ${shell.creator.name}`,
      description: "Tournament details and registration on start.gg.",
      noindex: loaderData.preview,
    });
    return withStylesheet(head, servicesStyles);
  },
  component: Tournament,
});

function Tournament() {
  return <TournamentDetail tournament={Route.useLoaderData()} />;
}
